import React from "react";
import PropTypes from "prop-types";

import Navbar from "./Navbar";
import SectionContainer from "core/SectionContainer";
import OffsetGrid from "core/OffsetGrid";
import Heading from "core/Heading";
import ProgressBar from "core/ProgressBar";
import colors from "core/colors";

const steps = [
    {
        text: "Payment",
        isActive: true
    },
    {
        text: "Download"
    }
];

const PageHeading = ({
    isPrepaid,
    pageHeading,
    thumbnail,
    imageTitle,
    slugWithId,
    type
}) => (
    <>
        <Navbar type={type} thumbnail={thumbnail} imageTitle={imageTitle} />

        <SectionContainer
            bgColor={colors.secondary.orca}
            topSpacing="none"
            bottomSpacing={isPrepaid ? "2xl" : "lg"}
            fullWidth
        >
            <OffsetGrid sm={12} md={12} lg={12}>
                <Heading
                    type="h1"
                    size="lg"
                    topSpacing="4xl"
                    bottomSpacing="lg"
                    alignment="center"
                    headingColor={colors.primary.diamond}
                >
                    {pageHeading}
                </Heading>

                <ProgressBar progressSteps={steps} />
            </OffsetGrid>
        </SectionContainer>
    </>
);

PageHeading.propTypes = {
    isPrepaid: PropTypes.bool,
    type: PropTypes.oneOf(["icons", "photos"]),
    pageHeading: PropTypes.string.isRequired,
    thumbnail: PropTypes.string.isRequired,
    imageTitle: PropTypes.string.isRequired,
    slugWithId: PropTypes.string.isRequired
};

export default PageHeading;
